import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { HomepageContent } from "../../../site";
import { HomeDataResponse, HomePageFactory } from "../../core";

export class HomePageFactoryImpl implements HomePageFactory {
    create(homeData: HomeDataResponse | undefined): ReactElement<any, string | JSXElementConstructor<any>> {
        if (homeData?.success && homeData.success === true) {
            if (homeData.response.mostViewedItems.length == 0) return <NoDataComponent invitation={true} />
            return <HomepageContent data={homeData.response} />
        }
        return <NoDataComponent />
    }
}